/* =========================================================================
   Upgreens: Kaufleiste am unteren Rand der Produktseite
   (sections/ug-kaufleiste.liquid)

   DREI AUFGABEN:
     1. zeigen und verstecken, je nachdem wo man auf der Seite steht
     2. ein Klick auf eine Farbe setzt den ECHTEN Schalter der Produktseite
     3. ein Klick auf den Knopf druckt den ECHTEN Kaufen-Knopf

   WARUM UEBER DIE ECHTEN ELEMENTE UND NICHT SELBST:
   Es gibt dann nur einen Zustand. Ein eigenes Formular muesste Varianten-Id,
   Menge, Zubehoer und Verfuegbarkeit nachhalten; jede dieser vier Stellen
   koennte auseinanderlaufen, und die teuerste davon legt stillschweigend
   die falsche Farbe in den Warenkorb.

   WARUM EIN SCROLL-LAUSCHER UND KEIN IntersectionObserver:
   Der Beobachter war die erste Fassung und ist an einer Stelle gescheitert,
   die im Betrieb vorkommt. Er meldet sich nur, wenn sich der Zustand
   AENDERT. Springt die Seite vom Anfang direkt an eine Stelle hinter dem
   Kaufen-Knopf — ein Anker im Link, die wiederhergestellte Scrollposition
   beim Zurueckgehen, ein Sprungziel aus Mottos schwebender Leiste —, dann
   war der Knopf vorher „nicht im Bild" (weil er darunter lag) und ist
   danach „nicht im Bild" (weil er darueber liegt). Kein Wechsel, keine
   Meldung, keine Leiste. Genau so im Viewer gemessen, bevor das hier
   gepusht wurde.

   Der Lauscher rechnet deshalb selbst, aber hoechstens einmal pro Bild:
   `requestAnimationFrame` fasst zusammen, was waehrend eines Scrollzugs
   anfaellt, und gerechnet werden drei Rechtecke. Das ist weniger, als ein
   einziges Bild der Seite kostet.

   WARUM ALLES UEBER `document` DELEGIERT IST:
   Im Theme-Editor tauscht Shopify einzelne Abschnitte aus, ohne die Seite
   neu zu laden. Lauscher am Element waeren danach an einem Knoten, den es
   nicht mehr gibt. Deshalb wird die Leiste bei jedem Zugriff frisch
   gesucht und `starten()` laeuft nach jedem Austausch erneut.
   ========================================================================= */
(function () {
  'use strict';

  var vorbei = false;
  var andereSichtbar = false;
  var untenAngekommen = false;
  var grundtext = '';
  var wartetAufBild = false;

  function leiste() {
    return document.querySelector('[data-ug-kaufleiste]');
  }

  /* Der echte Kaufen-Knopf der Produktseite. Mottos schwebende Leiste
     (`product-form--floating`) ist ausgenommen, sonst gaebe es je nach
     Theme-Einstellung zwei Kandidaten. Es zaehlt der erste, der wirklich
     im Dokument steht — Schnellkauf-Fenster sind ausgeblendet und haben
     kein `offsetParent`. */
  function kaufKnopf() {
    var alle = document.querySelectorAll('product-form:not(.product-form--floating) [name="add"]');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].offsetParent !== null) return alle[i];
    }
    return null;
  }

  function zeichnen() {
    var el = leiste();
    if (!el) return;
    /* Im Theme-Editor steht die Leiste immer. Sonst waere sie nicht
       einstellbar: der Editor zeigt die Seite am Anfang, und dort ist der
       Kaufen-Knopf noch im Bild. */
    var immer = el.hasAttribute('data-ug-immer');
    var zeigen = immer || (vorbei && !andereSichtbar && !untenAngekommen);
    el.classList.toggle('ug-kaufleiste--an', zeigen);
    /* `inert` nimmt die versteckte Leiste aus der Tabulatorreihenfolge und
       aus der Vorlesehilfe. Ohne das stolpert man mit der Tastatur in
       Knoepfe, die niemand sieht. */
    if (zeigen) {
      el.removeAttribute('inert');
    } else {
      el.setAttribute('inert', '');
    }
  }

  /* ---- Farbe waehlen ----------------------------------------------------- */

  /* Mottos Radiofeld zu einem Optionswert. Der Name lautet dort
     „<Option>-<Sektion>-<Produkt>", deshalb reicht der Wert allein nicht:
     bei zwei Optionen mit gleichem Wert traefe er die falsche. */
  function echtesFeld(optionName, wert) {
    var felder = document.querySelectorAll(
      'variant-radios input[type="radio"], variant-selects input[type="radio"]'
    );
    for (var i = 0; i < felder.length; i++) {
      var f = felder[i];
      if (f.value === wert && f.name.indexOf(optionName + '-') === 0) return f;
    }
    return null;
  }

  function waehlen(el) {
    var gruppe = el.closest('[data-ug-leiste-option]');
    if (!gruppe) return;
    var feld = echtesFeld(
      gruppe.getAttribute('data-ug-leiste-option'),
      el.getAttribute('data-ug-leiste-wert')
    );
    if (!feld || feld.checked) return;
    feld.checked = true;
    /* `change`, nicht `click`: ein Klick auf ein bereits markiertes Feld
       loest nichts aus, und Mottos `variant-radios` horcht ohnehin auf
       `change`. */
    feld.dispatchEvent(new Event('change', { bubbles: true }));
    nachziehenZweimal();
  }

  /* ---- Mit der Seite gleichziehen ---------------------------------------- */

  function nachziehen() {
    var el = leiste();
    if (!el) return;

    var gruppe = el.querySelector('[data-ug-leiste-option]');
    if (gruppe) {
      var name = gruppe.getAttribute('data-ug-leiste-option');
      gruppe.querySelectorAll('[data-ug-leiste-wert]').forEach(function (feld) {
        var echt = echtesFeld(name, feld.getAttribute('data-ug-leiste-wert'));
        if (!echt) return;
        feld.setAttribute('aria-checked', echt.checked ? 'true' : 'false');
        /* Motto markiert nicht lieferbare Werte mit `disabled` als KLASSE,
           nicht als Attribut. */
        if (echt.classList.contains('disabled')) {
          feld.setAttribute('data-ug-leer', '1');
        } else {
          feld.removeAttribute('data-ug-leer');
        }
      });
    }

    var knopf = kaufKnopf();
    var eigener = el.querySelector('[data-ug-leiste-knopf]');
    var text = el.querySelector('[data-ug-leiste-text]');
    if (!knopf || !eigener) return;
    eigener.disabled = knopf.disabled;
    if (text) {
      text.textContent = knopf.disabled
        ? el.getAttribute('data-ug-ausverkauft') || grundtext
        : grundtext;
    }
  }

  /* Motto baut Preis und Farbwahl nach einem Wechsel neu auf. Der zweite
     Durchgang holt das ein; der erste haelt die Leiste in der Zwischenzeit
     richtig. */
  function nachziehenZweimal() {
    nachziehen();
    window.setTimeout(nachziehen, 450);
  }

  /* ---- In den Einkaufswagen ---------------------------------------------- */

  function legen(eigener) {
    var knopf = kaufKnopf();
    if (!knopf || knopf.disabled) return;
    eigener.disabled = true;
    knopf.click();
    /* Danach oeffnet sich die Warenkorb-Schublade und die Leiste ist
       ohnehin verdeckt. Der Knopf wird trotzdem wieder scharf gemacht,
       falls das Hinzufuegen fehlschlaegt und die Schublade zubleibt. */
    window.setTimeout(function () {
      eigener.disabled = false;
      nachziehen();
    }, 1500);
  }

  /* ---- Einmalige Lauscher, am Dokument ----------------------------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ug-kaufleiste]')) return;
    var farbe = e.target.closest('[data-ug-leiste-wert]');
    if (farbe) {
      waehlen(farbe);
      return;
    }
    var eigener = e.target.closest('[data-ug-leiste-knopf]');
    if (eigener) legen(eigener);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') nachziehenZweimal();
  });

  /* ---- Wo stehen wir auf der Seite --------------------------------------- */

  function imBild(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  function pruefen() {
    var knopf = kaufKnopf();
    /* „Vorbei" heisst: der Knopf ist nach OBEN aus dem Bild. Steht er noch
       darunter, war man noch nicht dort, und die Leiste haette nichts
       anzubieten, was die Seite nicht gerade selbst zeigt. */
    var vorbeiNeu = knopf ? knopf.getBoundingClientRect().bottom <= 0 : false;

    var andereNeu = false;
    var andere = document.querySelectorAll('[data-ug-kaufen]');
    for (var i = 0; i < andere.length; i++) {
      if (imBild(andere[i])) {
        andereNeu = true;
        break;
      }
    }

    /* UNTEN BLEIBT SIE WEG. Der unterste Kaufblock steht direkt ueber dem
       Fussbereich. Scrollte man an ihm vorbei, kam die Leiste zurueck und
       legte sich ueber die Zeile mit Impressum und Widerrufsrecht. Gemessen
       am 22.10.2026 bei 375px: Leiste 61px hoch, ab y 751; die Rechtslinks
       endeten bei 753. Zum Antippen blieben zwei Pixel.

       Rechtstexte muessen erreichbar sein. Anzubieten hatte die Leiste dort
       ohnehin nichts: eine Fingerlaenge hoeher steht derselbe Knopf in
       gross.

       `top <= Fensterhoehe` heisst: der Block hat die Unterkante des Bildes
       erreicht — genau der Moment, in dem man unten ankommt. Und es bleibt
       wahr, solange man weiter nach unten scrollt, anders als `imBild`. */
    var letzter = andere.length ? andere[andere.length - 1] : null;
    var untenNeu = letzter
      ? letzter.getBoundingClientRect().top <= (window.innerHeight || document.documentElement.clientHeight)
      : false;

    if (vorbeiNeu === vorbei && andereNeu === andereSichtbar && untenNeu === untenAngekommen) return;
    vorbei = vorbeiNeu;
    andereSichtbar = andereNeu;
    untenAngekommen = untenNeu;
    zeichnen();
  }

  function anstossen() {
    if (wartetAufBild) return;
    wartetAufBild = true;
    window.requestAnimationFrame(function () {
      wartetAufBild = false;
      pruefen();
    });
  }

  window.addEventListener('scroll', anstossen, { passive: true });
  window.addEventListener('resize', anstossen, { passive: true });

  /* ---- Start, auch nach einem Austausch im Editor ------------------------- */

  function starten() {
    if (!leiste()) return;
    var text = leiste().querySelector('[data-ug-leiste-text]');
    grundtext = text ? text.textContent : '';
    nachziehen();
    pruefen();
    zeichnen();
  }

  starten();
  document.addEventListener('shopify:section:load', starten);
})();
